<div [ngClass]="{ 'mb-3': hasMarginBottom }">
  <input
    #file
    (change)="fileUpload($event)"
    (focus)="upload.focus()"
    [accept]="config.accept"
    [disabled]="this.uploadedFiles() && this.uploadedFiles().length >= config.maxAmountOfFiles"
    data-test="hidden-file-upload"
    name="image"
    type="file"
    onClick="this.value=null"
    tabindex="-1"
    class="visually-hidden"
  />

  <mwe-button-link #upload (clicked)="onUploadClicked()" label="upload.uploadButton.text" ariaDescribedBy="mwe-extended-upload-desc">
    <i aria-hidden="true" class="fa-solid fa-cloud-arrow-up mr-2 w-max-content fs-6 text-decoration-none"></i>
  </mwe-button-link>

  @if (showLoadingSpinner()) {
    <mwe-loading-spinner />
  }

  @if (showUploadError()) {
    <mwe-inline-notification [messageKey]="config.uploadErrorMsgKey" type="danger" />
  }
</div>
